import Vue from 'vue'
import Router from 'vue-router'
import choose from '@/components/choose'
import upload from '@/components/upload'
import rule from '@/components/rule'
import index from '@/components/index'
import index1 from '@/components/index1'
import popup from '@/components/popup'
import uploadimg from '@/components/uploadimg'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'index1',
      component: index1
    },
    {
      path: '/uploadimg',
      name: 'uploadimg',
      component: uploadimg
    },
    {
      path: '/rule',
      name: 'rule',
      component: rule
    },
    {
      path: '/popup',
      name: 'popup',
      component: popup
    },
    {
      path: '/upload',
      name: 'upload',
      component: upload
    },
    {
      path: '/choose',
      name: 'choose',
      component: choose
    },
    {
      path: '/index1',
      name: 'index1',
      component: index1
    },
  ]
})


// WEBPACK FOOTER //
// ./src/router/index.js